import { getBanks } from "@/services/bankService";
import { useQuery } from "react-query";

export const useBanks = () => {
  return useQuery({
    queryKey: ["banks"],
    queryFn: getBanks,
  });
};
